import React, { useState, useEffect } from "react";
import {
  FaQuoteRight,
  FaStar,
  FaArrowLeft,
  FaArrowRight,
  FaUserMd,
  FaHospital,
  FaClinicMedical,
  FaUserNurse,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import "./Testimonials.css";

const testimonials = [
  {
    id: 1,
    name: "Dr. Rahul Sharma",
    role: "Medical Practitioner",
    icon: <FaUserMd className="profile-icon" />,
    rating: 5,
    text: "The service is exceptional! The platform has streamlined my medical supply procurement. Fast delivery and genuine products make it my go-to choice.",
  },
  {
    id: 2,
    name: "Priya Patel",
    role: "Hospital Administrator",
    icon: <FaHospital className="profile-icon" />,
    rating: 5,
    text: "As a healthcare administrator, I highly recommend this platform. The range of medical supplies is extensive and the quality is consistently outstanding.",
  },
  {
    id: 3,
    name: "Dr. Amit Kumar",
    role: "Clinic Owner",
    icon: <FaClinicMedical className="profile-icon" />,
    rating: 5,
    text: "Exceptional service quality and reliable delivery. Their customer support is outstanding and the prices are very competitive in the market.",
  },
  {
    id: 4,
    name: "Sneha Reddy",
    role: "Healthcare Professional",
    icon: <FaUserNurse className="profile-icon" />,
    rating: 5,
    text: "Perfect for bulk medical supplies. The ordering process is smooth, and they maintain high standards of quality control. Highly recommended!",
  },
];

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [direction, setDirection] = useState(0);

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setDirection(1);
        setCurrentSlide((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    }),
  };

  const nextSlide = () => {
    setDirection(1);
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevSlide = () => {
    setDirection(-1);
    setCurrentSlide(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
    setIsAutoPlaying(false);
  };

  return (
    <motion.div
      className="testimonials-section"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="testimonials-header">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Trusted by Healthcare Professionals
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Hear what our valued customers say about our services
        </motion.p>
      </div>

      <div className="testimonials-carousel">
        <motion.button
          className="carousel-button prev"
          onClick={prevSlide}
          whileHover={{ scale: 1.1, backgroundColor: "#f88a4a" }}
          whileTap={{ scale: 0.95 }}
        >
          <FaArrowLeft size={18} />
        </motion.button>

        <AnimatePresence initial={false} custom={direction}>
          <motion.div
            key={currentSlide}
            custom={direction}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
              x: { type: "spring", stiffness: 300, damping: 30 },
              opacity: { duration: 0.2 },
            }}
            className="testimonial-card"
          >
            <div className="quote-icon">
              <FaQuoteRight />
            </div>

            <div className="testimonial-content">
              <div className="testimonial-text">
                {testimonials[currentSlide].text}
              </div>

              <div className="testimonial-rating">
                {[...Array(testimonials[currentSlide].rating)].map((_, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.1 }}
                  >
                    <FaStar className="star-icon" />
                  </motion.div>
                ))}
              </div>

              <div className="testimonial-author">
                <div className="author-icon">
                  {testimonials[currentSlide].icon}
                </div>
                <div className="author-info">
                  <h4>{testimonials[currentSlide].name}</h4>
                  <p>{testimonials[currentSlide].role}</p>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <motion.button
          className="carousel-button next"
          onClick={nextSlide}
          whileHover={{ scale: 1.1, backgroundColor: "#f88a4a" }}
          whileTap={{ scale: 0.95 }}
        >
          <FaArrowRight size={18} />
        </motion.button>
      </div>

      <div className="carousel-dots">
        {testimonials.map((_, index) => (
          <motion.button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => {
              setCurrentSlide(index);
              setIsAutoPlaying(false);
            }}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default Testimonials;